module.exports = __webpack_public_path__ + "img/logo-colored-en.18b49bed.svg";